import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpoint.list.actions.delete.areYouSure': {
    defaultMessage: 'Are you sure you want to delete the checkpoint "<b>{displayName}</b>"?',
    id: 'checkpoint.deletion.areYouSure'
  },
  'checkpoint.list.actions.delete.description': {
    defaultMessage: '<i>NOTE</i>: Please ensure downloaded work is up to date on the Memo to reflect changes.',
    id: 'checkpoint.deletion.description'
  },
  'checkpoint.list.actions.delete.modalTitle': {
    defaultMessage: 'Delete Checkpoint?',
    id: 'checkpoint.actions.delete.modalTitle'
  },
  'checkpoint.list.assign.failure': {
    defaultMessage: 'Checkpoint assignment failed - is your checkpoint name unique?',
    id: 'checkpoint.list.assign.failure'
  },
  'checkpoint.list.assign.success': {
    defaultMessage: 'Checkpoints successfully assigned',
    id: 'checkpoint.list.assign.success'
  },
  'checkpoint.list.delete.failure': {
    defaultMessage: 'Checkpoint deletion failed',
    id: 'checkpoint.list.deletion.failure'
  },
  'checkpoint.list.delete.success': {
    defaultMessage: 'Checkpoint deleted successfully',
    id: 'checkpoint.list.deletion.success'
  },
  'checkpoint.list.unassign.failure': {
    defaultMessage: 'Checkpoint unassignment failed - is your checkpoint name unique?',
    id: 'checkpoint.list.unassign.failure'
  },
  'checkpoint.list.unassign.success': {
    defaultMessage: 'Checkpoints successfully unassigned',
    id: 'checkpoint.list.unassign.success'
  },
  'checkpoints.list.actions': {
    defaultMessage: 'Actions',
    id: 'checkpoints.list.actions'
  },
  'checkpoints.list.checkBox.label': {
    defaultMessage: 'select all checkpoints',
    id: 'checkpoints.list.checkBox.label'
  },
  'checkpoints.list.created': {
    defaultMessage: 'Created',
    id: 'checkpoints.list.created'
  },
  'checkpoints.list.delete': {
    defaultMessage: 'Delete',
    id: 'checkpoints.list.delete'
  },
  'checkpoints.list.description': {
    defaultMessage: 'Description',
    id: 'checkpoints.list.description'
  },
  'checkpoints.list.displayedRows': {
    defaultMessage: '{from, number}-{to, plural, =-1 {{count, number}} other {#}} of {count, plural, =-1 {more than {to, number}} other {#}}',
    id: 'checkpoints.list.displayedRows'
  },
  'checkpoints.list.empty.action': {
    defaultMessage: 'Create a checkpoint',
    id: 'checkpoints.list.empty.action'
  },
  'checkpoints.list.empty.primary': {
    defaultMessage: 'No checkpoints',
    id: 'checkpoints.list.empty.primary'
  },
  'checkpoints.list.empty.secondary': {
    defaultMessage: 'Your account has no checkpoints yet.',
    id: 'checkpoints.list.empty.secondary'
  },
  'checkpoints.list.loading': {
    defaultMessage: 'Loading...',
    id: 'checkpoints.list.loading'
  },
  'checkpoints.list.location': {
    defaultMessage: 'Location',
    id: 'checkpoints.list.location'
  },
  'checkpoints.list.name': {
    defaultMessage: 'Name',
    id: 'checkpoints.list.name'
  },
  'checkpoints.list.pagination.label': {
    defaultMessage: 'Rows per page',
    id: 'checkpoints.list.pagination.label'
  },
  'checkpoints.list.rowsPerPage': {
    defaultMessage: 'Rows per page',
    id: 'checkpoints.list.rowsPerPage'
  },
  'checkpoints.list.sequenceNumber': {
    defaultMessage: 'Visit Order',
    id: 'checkpoints.list.sequenceNumber'
  },
  'checkpoints.list.types': {
    defaultMessage: 'Checkpoint Types',
    id: 'checkpoints.list.types'
  },
  'checkpoints.list.update': {
    defaultMessage: 'Update',
    id: 'checkpoints.list.update'
  },
  'checkpoints.list.updated': {
    defaultMessage: 'Updated',
    id: 'checkpoints.list.updated'
  },
  'checkpoints.navbar.assign': {
    defaultMessage: 'Assign',
    id: 'checkpoints.navbar.assign'
  },
  'checkpoints.navbar.assignTitle': {
    defaultMessage: 'Assign new location',
    id: 'checkpoints.navbar.assignTitle'
  },
  'checkpoints.navbar.bulkActions': {
    defaultMessage: 'Bulk Actions',
    id: 'checkpoints.navbar.bulkActions'
  },
  'checkpoints.navbar.clearAll': {
    defaultMessage: 'Clear selected',
    id: 'checkpoints.navbar.clearAll'
  },
  'checkpoints.navbar.selectedCheckpoints': {
    defaultMessage: 'Selected Checkpoints',
    id: 'checkpoints.navbar.selectedCheckpoints'
  },
  'checkpoints.navbar.selectedLocation': {
    defaultMessage: 'Change location',
    id: 'checkpoints.navbar.selectedLocation'
  },
  'checkpoints.navbar.selection': {
    defaultMessage: 'Selection',
    id: 'checkpoints.navbar.selection'
  },
  'checkpoints.navbar.unassign': {
    defaultMessage: 'Unassign',
    id: 'checkpoints.navbar.unassign'
  },
  'checkpoints.navbar.unassignTitle': {
    defaultMessage: 'Unassign location',
    id: 'checkpoints.navbar.unassignTitle'
  }
});
